import { Injectable } from '@angular/core';
import { IUser } from '@app/modules/user/interface/user';
import { AppHttpClient } from '@app/shared/services/http.service';
import { Observable, ReplaySubject } from 'rxjs';
import { ModelAttributes } from '@app/core/interface/common';
import { CRITICAL_INFO_TYPE } from '@app/modules/critical-info/consts/type';

@Injectable()
export class UserHttpService {
  /**
   * @param http
   */
  public constructor(private readonly http: AppHttpClient) {}

  public getUser(): Observable<IUser> {
    const result = new ReplaySubject<IUser>(1);

    this.http.get('accounts/self').subscribe(
      (response: IUser) => result.next(response),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }

  public getPatients(): Observable<any> {
    const result = new ReplaySubject(1);

    this.http.get('target/accesses').subscribe(
      (response: ModelAttributes[]) => {
        response.forEach((patient) => {
          if (patient.livingWill) {
            for (const critInfoKey of Object.keys(patient.livingWill)) {
              if (CRITICAL_INFO_TYPE[critInfoKey])
                patient.livingWill = {
                  ...patient.livingWill,
                  [critInfoKey]: {
                    value: patient.livingWill[critInfoKey],
                    key: critInfoKey,
                  },
                };
            }
          }
        });
        return result.next(response);
      },
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }

  public createUser(user: IUser): Observable<boolean> {
    const result = new ReplaySubject<boolean>(1);
    let model: ModelAttributes = {
      role: user.role,
      email: user.email,
      password: "user.password",
      pin: "user.pin"
      //cognitoId: user.cognitoId,
    };

    // required fields for registration by referral link
    if (user.invitationId && user.inviterId) {
      model = {
        ...model,
        invitationInfo: {
          inviterId: +user.inviterId,
          invitationId: +user.invitationId,
        },
      };
    }

    this.http.post(`accounts/create`, model).subscribe(
      ({ success }) => result.next(success),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }

  public updateUser(user: IUser): Observable<IUser> {
    const result = new ReplaySubject<IUser>(1);

    this.http.patch(`accounts/self`, user).subscribe(
      () => result.next(user),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }

  public uploadUserAvatar(data: FormData): Observable<string> {
    const result = new ReplaySubject<string>(1);

    this.http.put('accounts/avatar', data).subscribe(
      ({ location }) => result.next(location),
      ({ error }) => result.error(error)
    );

    return result.asObservable();
  }
}
